import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import pure from 'recompose/pure'
import { showAudioLanguageContextMenu } from 'aria-viewer/contextmenu/contextMenuActions'
import ContextButton from './contextButton'
import {
    optIn,
    AUDIO_TOUR,
    AUDIO_LOAD,
    AUDIO_PLAY,
    stopAudio,
    playAudio,
} from 'aria-viewer/audiomanager/audioManagerActions'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import Icon from 'aria-viewer/tour/components/icon'
import Radium from 'radium'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import { MAIN_AUDIO_BUTTON_INDEX } from 'aria-viewer/keyboard/constants/tabIndices'
import { KEY_CODES } from 'aria-viewer/tour/constants/index'
import compose from 'recompose/compose'

const CSSAnimNames = {
    rotate: Radium.keyframes(
        {
            '0%': {
                transform: 'translate(-50%,-50%) rotate(0)',
            },
            '100%': {
                transform: 'translate(-50%,-50%) rotate(360deg)',
            },
        },
        'rotate'
    ),
    dash: Radium.keyframes(
        {
            '0%': {
                strokeDasharray: '1, 150',
                strokeDashoffset: 0,
            },
            '50%': {
                strokeDasharray: '90, 150',
                strokeDashoffset: -35,
            },
            '100%': {
                strokeDasharray: '90, 150',
                strokeDashoffset: -124,
            },
        },
        'dash'
    ),
}

const S = {
    loadingContainerBase: {
        width: '100%',
        height: '100%',
    },
    loadingContainerWSVG: {
        position: 'relative',
        bottom: '2.5em',
    },
    loadingIconSVG: {
        display: 'block',
        animation: 'x 2s linear infinite',
        animationName: CSSAnimNames.rotate,
        zIndex: 2,
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: '50%',
        height: '50%',
        transform: 'translate(-50%, -50%)',
    },
    loadingIconSVGCicle: {
        stroke: 'white',
        strokeLinecap: 'round',
        animation: 'x 1.5s ease-in-out infinite',
        animationName: CSSAnimNames.dash,
    },
    iconStyle: {
        ':hover': { backgroundSize: '55%' },
    },
    iconContainerSpan: { color: '#FFFFFF' },
}

const IconContainer = Radium(
    pure(function IconContainer({ icon, puresvg, isLoading, autoplay }) {
        const showLoadingIndicator = isLoading && autoplay
        return (
            <div
                style={Object.assign(
                    { ...S.loadingContainerBase }, //if loading, change container
                    puresvg ? S.loadingContainerWSVG : null
                )}
            >
                {' '}
                {// first, loading container
                showLoadingIndicator && (
                    <svg style={S.loadingIconSVG} viewBox="0 0 50 50">
                        <circle style={S.loadingIconSVGCicle} cx="25" cy="25" r="20" fill="none" strokeWidth="5" />
                    </svg>
                )}
                {// then, icon itself
                !isLoading && !puresvg && <Icon style={S.iconStyle} icon={icon} />}
            </div>
        )
    })
)

class AudioButton extends PureComponent {
    static defaultProps = {
        onIcon: 'audio_on',
        offIcon: 'audio_off',
    }

    onClick = e => {
        const {
            languages,
            onClick,
            showAudioLanguageContextMenu,
            isSingleAudioLanguage,
            stopAudio,
            playAudio,
            optIn,
            audioManager,
        } = this.props

        if (languages) {
            if (onClick) {
                onClick(e)
            } else if (isSingleAudioLanguage) {
                if (audioManager.getIn(['state', AUDIO_TOUR]) === AUDIO_PLAY) {
                    stopAudio(AUDIO_TOUR)
                } else {
                    playAudio(AUDIO_TOUR)
                    optIn()
                }
            } else {
                showAudioLanguageContextMenu(e)
            }
        }
    }

    render() {
        const { languages, audioManager, puresvg, style, onIcon, offIcon, className, autoplay } = this.props

        const isPlaying = audioManager.getIn(['state', AUDIO_TOUR]) === AUDIO_PLAY,
            isLoading = this.props.audioManager.getIn(['state', AUDIO_TOUR]) === AUDIO_LOAD

        return (
            <ContextButton
                className={className}
                id="context_audio_button"
                style={{
                    opacity: languages ? 1 : 0.4,
                    position: 'relative',
                    overflow: 'hidden',
                    ...style,
                }}
                /* press Ctrl+m to toggle the audio */
                keyboard={KEY_CODES.M}
                keyboardCtrl={true}
                tabIndex={MAIN_AUDIO_BUTTON_INDEX}
                onClick={this.onClick}
                theme="button_rounded_transparent"
                puresvg={puresvg}
                alt="audio"
                icon={!isLoading ? (isPlaying ? onIcon : offIcon) : autoplay ? 'none' : offIcon}
            >
                <IconContainer
                    icon={isPlaying ? onIcon : offIcon}
                    isLoading={isLoading}
                    puresvg={puresvg}
                    autoplay={autoplay}
                />
            </ContextButton>
        )
    }
}

const mapStateToProps = state => ({
    autoplay: state.getIn(['audioManager', 'autoplay']),
})

export default compose(
    connect(mapStateToProps),
    connect(
        mapSelectorsToProps(['audioManager', 'languages', 'isSingleAudioLanguage']),
        {
            showAudioLanguageContextMenu,
            playAudio,
            stopAudio,
            optIn,
        }
    )
)(Radium(AudioButton))
